import {createAction} from "@reduxjs/toolkit";

export const setPipelineInsightsFilter = createAction<{
  fromDttm: number,
  toDttm?: number
}>("ui/pipeline-insights/setFilter");
